import React, { useEffect, useRef, useState } from "react";
import { IoIosArrowDown } from "react-icons/io";
import { HiOutlineAdjustmentsHorizontal } from "react-icons/hi2";
import AllFilters from "./AllFilter/AllFilters";
import "react-date-range-ts/dist/styles.css";
import "react-date-range-ts/dist/theme/default.css";
import { DateRange } from "react-date-range-ts";
import { toast } from "react-toastify";
import { endOfDay, endOfMonth, startOfDay, startOfMonth, subDays } from "date-fns";

type PendingSettlementFilter =
  | { kind: "preset"; label: string; days: number; endDate: Date }
  | { kind: "custom"; startDate: Date; endDate: Date }
  | null;

function Filters(props: any) {
  const [dropDownOpt, setDropDownOpt] = useState<any>({
    date: false,
    status: false,
    allFilters: false,
    backdrop: false,
  });
  const [tempSelectedTime, setTempSelectedTime] = useState<string>(props.selectedTime);
  const [tempDateRange, setTempDateRange] = useState<any>(props.dateRange);


  const [localSelectedRange, setLocalSelectedRange] = useState({
    startDate: new Date(),
    endDate: new Date(),
    key: "selection",
  });
  const [settlementType, setSettlementType] = useState("");

  const dateRef = useRef<HTMLDivElement>(null);


  const [pendingSettlement, setPendingSettlement] =
    useState<PendingSettlementFilter>(null);

  const toogleDropDownOpt = (dropdownName: string) => {
    const updatedDropdowns = Object.keys(dropDownOpt).reduce(
      (acc: any, name) => {
        acc[name] = name === dropdownName ? !dropDownOpt[name] : false;
        return acc;
      },
      {}
    );
    setDropDownOpt(updatedDropdowns);
  };

  const handleTimeFilter = (type: string) => {
    if (type !== "Custom Date Range") {
      setTempDateRange([{ startDate: new Date(), endDate: null, key: "selection" }]);
    }
    setTempSelectedTime(type);
  };

  const clearFilter = (type: string) => {
    toogleDropDownOpt("status");
    if (type === "clear") {
      props.setCheckboxFilter(() => ({ size: 0, status: 0, mode: 0 }));
      return;
    }
    props.setSelectStatus((pre: any) => ({ ...pre, [type]: true }));
    type = type.toLowerCase();
    props.setCheckboxFilter((pre: any) => ({
      ...pre,
      [type]: true,
      size: pre.size + 1,
      status: pre.status + 1,
    }));
  };

  const handleClearTimeRange = () => {
    props.setSelectedTime("Date");
    setTempSelectedTime("Date");
    setTempDateRange([{ startDate: new Date(), endDate: new Date(""), key: "selection" }]);
    props.setDateRange([{ startDate: new Date(), endDate: new Date(""), key: "selection" }]);
    props.setDateFilter({
      type: "",
      startDate: "01/01/1970, 5:30:00 AM",
      endDate: new Date().toLocaleString("en-US", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      }),
    });
    toogleDropDownOpt("date");
  };

  const handleClearTimeRangeSettlement = () => {
    setPendingSettlement(null);
    props.setDateRange([
      {
        startDate: new Date(),
        endDate: new Date(""),
        key: "selection",
      },
    ]);
    props.setDateFilterType("");
    props.setEndDate("");
    props.setSelectDays(0);
    toogleDropDownOpt("date");
  };

  const applyDateFilter = () => {
    const dateFormatter = new Intl.DateTimeFormat("en-US", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    });
    let dateToFilter: Date;
    if (tempSelectedTime === "Today") {
      dateToFilter = new Date();
      props.setDateFilter({
        type: tempSelectedTime,
        startDate: dateFormatter.format(dateToFilter),
        endDate: dateFormatter.format(new Date()),
      });
    } else if (tempSelectedTime === "Last 7 days") {
      dateToFilter = new Date(new Date().getTime() - 7 * 24 * 60 * 60 * 1000);
      props.setDateFilter({
        type: tempSelectedTime,
        startDate: dateFormatter.format(dateToFilter),
        endDate: dateFormatter.format(new Date()),
      });
    } else if (tempSelectedTime === "This Month") {
      dateToFilter = new Date();
      dateToFilter.setDate(1);
      props.setDateFilter({
        type: tempSelectedTime,
        startDate: dateFormatter.format(dateToFilter),
        endDate: dateFormatter.format(new Date()),
      });
    } else if (tempSelectedTime === "Last Month") {
      dateToFilter = new Date();
      const lastDate = new Date();
      lastDate.setDate(1);
      lastDate.setDate(0);
      dateToFilter.setMonth(dateToFilter.getMonth() - 1);
      dateToFilter.setDate(1);
      props.setDateFilter({
        type: tempSelectedTime,
        startDate: dateFormatter.format(dateToFilter),
        endDate: dateFormatter.format(lastDate),
      });
    } else if (tempSelectedTime === "Custom Date Range" && tempDateRange[0].endDate) {
      props.setDateFilter({
        type: tempSelectedTime,
        startDate: dateFormatter.format(tempDateRange[0].startDate),
        endDate: dateFormatter.format(tempDateRange[0].endDate),
      });
    }
    props.setSelectedTime(tempSelectedTime);
    props.setDateRange(tempDateRange);
    toogleDropDownOpt("date");
  };

  const handlePresetFilter = (type: string) => {
    let startDate: Date, endDate: Date;
    switch (type) {
      case "today":
        startDate = startOfDay(new Date());
        endDate = endOfDay(new Date());
        setSettlementType("Today");
        break;
      case "last7days":
        startDate = subDays(new Date(), 7);
        endDate = new Date();
        setSettlementType("Last 7 days");
        break;
      case "thisMonth":
        startDate = startOfMonth(new Date());
        endDate = endOfMonth(new Date());
        setSettlementType("This Month");
        break;
      case "lastMonth":
        startDate = startOfMonth(subDays(new Date(), 30));
        endDate = endOfMonth(subDays(new Date(), 30));
        setSettlementType("Last Month");
        break;
      default:
        startDate = new Date();
        endDate = new Date();
        break;
    }
    setLocalSelectedRange({ startDate, endDate, key: "selection" });
  };

  const handleApplySettlement = () => {
    const { startDate, endDate } = localSelectedRange;
    if (!startDate || !endDate) {
      toast.error("Both start and end dates are required");
      return;
    }
    const timeDifference = new Date(endDate).getTime() - new Date(startDate).getTime();
    const daysDifference = Math.ceil(timeDifference / (24 * 60 * 60 * 1000));
    const label = settlementType === "Today" ? "Today" : "Custom Date";
    props.setDateFilterType(label);
    props.setStartDate(startDate);
    props.setEndDate(endDate);
    props.setSelectDays(daysDifference);
    // if (props.setSelectedTime) props.setSelectedTime(label);
    toogleDropDownOpt("date");
  };

  useEffect(() => {
    if (dropDownOpt.date) {
      if (props.transaction || props.refund) {
        setTempSelectedTime(props.selectedTime);
        setTempDateRange(props.dateRange);
      } else {
        setLocalSelectedRange({ startDate: new Date(), endDate: new Date(), key: "selection" });
        setSettlementType("");
      }
    }
  }, [dropDownOpt.date]);

  const handleClearSettlement = () => {
    const defaultRange = {
      startDate: startOfDay(new Date()),
      endDate: endOfDay(new Date()),
      key: "selection",
    };
    setLocalSelectedRange(defaultRange);
    setSettlementType("");
    props.setDateFilterType("");
    props.setEndDate("");
    props.setSelectDays(0);
    if (props.setSelectedTime) props.setSelectedTime("Date");
    props.setDateRange([{ startDate: new Date(), endDate: new Date(""), key: "selection" }]);
    toogleDropDownOpt("date");
  };

  useEffect(() => {
    if (dropDownOpt.date) {
      setTempSelectedTime(props.selectedTime);
      setTempDateRange(props.dateRange);
      setPendingSettlement(null);
    }
  }, [dropDownOpt.date, props.selectedTime, props.dateRange]);

  const pendingPresetLabel =
    pendingSettlement?.kind === "preset" ? pendingSettlement.label : null;

  const settlementApplyEnabled =
    pendingSettlement !== null ||
    (!isNaN(props.dateRange[0].endDate?.getTime()) && props.dateRange[0].startDate);

  return (
    <div className="flex gap-x-2 ml-auto">
      {/* Backdrop */}
      <div
        onClick={() => setDropDownOpt({ date: false, status: false, allFilters: false })}
        className={`${dropDownOpt.backdrop ? "fixed top-0 left-0 w-full h-full min-h-screen" : "hidden"}`}
      />

      {/* Date Filter */}
      <div className="relative bg-[#F6F8FA]" ref={dateRef}>
        <button
          onClick={() =>
            setDropDownOpt((pre: any) => ({
              date: !dropDownOpt.date,
              status: false,
              mode: false,
              backdrop: !dropDownOpt.date,
            }))
          }
          className="focus:outline-none border border-edviron_black rounded-md py-2 min-w-[11rem] text-xs text-left flex items-center"
        >
          <span className="mr-auto pl-2">{props.selectedTime}</span>
          <IoIosArrowDown className="ml-auto w-8" />
        </button>

        {dropDownOpt.date && (
          <div className="absolute right-0 mt-2 text-sm bg-white xl:min-w-[26rem] min-w-[20rem] px-8 pt-2 pb-4 rounded-md shadow-lg z-10 flex flex-col">
            <p className="p-2 text-sm text-center">Custom Range</p>

            {/* Transaction / Refund UI */}
            {props.transaction || props.refund ? (
              <>
                <div className="flex flex-col xl:flex-row gap-x-4">
                  <div className="text-[10px] shrink-0 grid grid-cols-2">
                    <button onClick={() => handleTimeFilter("Today")} className="p-1.5 cursor-pointer rounded-md text-left">Today</button>
                    <button onClick={() => handleTimeFilter("Last 7 days")} className="p-1.5 cursor-pointer rounded-md text-left">Last 7 days</button>
                    <button onClick={() => handleTimeFilter("This Month")} className="p-1.5 cursor-pointer rounded-md text-left">This Month</button>
                    <button onClick={() => handleTimeFilter("Last Month")} className="p-1.5 cursor-pointer rounded-md text-left">Last Month</button>
                  </div>
                  <DateRange
                    rangeColors={["#6687FF"]}
                    editableDateInputs={false}
                    onChange={(item: any) => { setTempDateRange([item.selection]); setTempSelectedTime("Custom Date Range"); }}
                    ranges={tempDateRange[0]?.startDate ? tempDateRange : props.dateRange}
                    maxDate={new Date()}
                    showDateDisplay={false}
                  />
                </div>
                <div className="flex justify-end items-center mt-2">
                  <button onClick={handleClearTimeRange} className="border px-3 py-1.5 rounded-lg mr-2 text-[#6687FFCC]">Clear</button>
                  <button
                    disabled={tempSelectedTime === "Date"}
                    onClick={applyDateFilter}
                    className={`${tempSelectedTime !== "Date" ? "bg-edviron_black text-white" : "bg-gray-100 text-gray-500"} px-3 py-1.5 rounded-lg`}
                  >Apply</button>
                </div>
              </>
            ) : (
              /* Settlement UI — identical structure to DateFilter.tsx */
              <>
                <div className="flex flex-col xl:flex-row gap-x-4">
                  <div className="text-[10px] shrink-0 grid grid-cols-2">
                    <button className="p-1.5 cursor-pointer rounded-md text-left" onClick={() => handlePresetFilter("today")}>Today</button>
                    <button className="p-1.5 cursor-pointer rounded-md text-left" onClick={() => handlePresetFilter("last7days")}>Last 7 Days</button>
                    <button className="p-1.5 cursor-pointer rounded-md text-left" onClick={() => handlePresetFilter("thisMonth")}>This Month</button>
                    <button className="p-1.5 cursor-pointer rounded-md text-left" onClick={() => handlePresetFilter("lastMonth")}>Last Month</button>
                  </div>
                  <DateRange
                    editableDateInputs={false}
                    rangeColors={["#6687FF"]}
                    ranges={[localSelectedRange]}
                    onChange={(item: any) => { setLocalSelectedRange(item.selection); setSettlementType(""); }}
                    maxDate={new Date()}
                    showDateDisplay={false}
                  />
                </div>
                <div className="flex justify-end items-center mt-2">
                  <button onClick={handleClearSettlement} className="border px-3 py-1.5 rounded-lg mr-2 text-[#6687FFCC]">Clear</button>
                  <button onClick={handleApplySettlement} className="disabled:bg-gray-100 disabled:text-gray-500 bg-edviron_black text-white px-3 py-1.5 rounded-lg">Apply</button>
                </div>
              </>
            )}
          </div>
        )}
      </div>

      {/* Status Filter */}
      <div className="relative text-sm bg-[#F6F8FA]">
        <button
          onClick={() =>
            setDropDownOpt((pre: any) => ({
              date: false,
              status: !dropDownOpt.status,
              allFilters: false,
              backdrop: !dropDownOpt.status,
            }))
          }
          className="border border-edviron_black text-xs rounded-md py-2 min-w-[11rem] text-left flex items-center"
        >
          <span className="mr-auto pl-2">Status</span>
          <IoIosArrowDown className="ml-auto w-8" />
        </button>
        {dropDownOpt.status &&
          (props.transaction || props.refund ? (
            <ul className="absolute bg-white min-w-[11rem] py-2 mt-2 rounded-md shadow-lg z-10">
              <li
                onClick={() => {
                  if (!props.selectStatus.Success) {
                    clearFilter("Success");
                  }
                }}
                className="py-2 pl-4 cursor-pointer mb-2"
              >
                Success
              </li>
              <li
                onClick={() => {
                  if (!props.selectStatus.Pending) {
                    clearFilter("Pending");
                  }
                }}
                className="py-2 pl-4 cursor-pointer mb-2"
              >
                Pending
              </li>
              <li
                onClick={() => {
                  if (!props.selectStatus.Failed) {
                    clearFilter("Failed");
                  }
                }}
                className="py-2 pl-4 cursor-pointer"
              >
                Failed
              </li>
            </ul>
          ) : (
            <ul className="absolute bg-white min-w-[11rem] py-2 mt-2 rounded-md shadow-lg z-10">
              <li
                onClick={() => {
                  props.setSettlementStatusFilter("Settled");
                  toogleDropDownOpt("status");
                }}
                className="py-2 pl-4 cursor-pointer mb-2"
              >
                Settled
              </li>
              <li
                onClick={() => {
                  props.setSettlementStatusFilter("Pending");
                  toogleDropDownOpt("status");
                }}
                className="py-2 pl-4 cursor-pointer mb-2"
              >
                Pending
              </li>
            </ul>
          ))}
      </div>

      {/* All Filters (transaction only) */}
      {props.transaction && (
        <div className="relative bg-[#F6F8FA]">
          <button
            onClick={() =>
              setDropDownOpt((pre: any) => ({
                date: false,
                status: false,
                allFilters: !dropDownOpt.allFilters,
                backdrop: !dropDownOpt.allFilters,
              }))
            }
            className="border text-xs rounded-md py-2 min-w-[11rem] text-left flex items-center"
          >
            <span className="mr-auto pl-2">All Filters</span>
            <HiOutlineAdjustmentsHorizontal className="ml-auto w-8" />
          </button>
          {dropDownOpt.allFilters && (
            <AllFilters
              schoolData={props.schoolData}
              checkboxFilter={props.checkboxFilter}
              setSchoolFilter={props.setSchoolFilter}
              schoolFilter={props.schoolFilter}
              setCheckboxFilter={props.setCheckboxFilter}
            />
          )}
        </div>
      )}
    </div>
  );
}

export default Filters;